import axios from "axios";

class Merchant {
  request(emit, data) {
    return axios.post(`/merchant-interact-request?emit=${emit}`, data);
  }
}

export default new Merchant();
